import { gql } from '@apollo/client'

export const GET_SLI_VALIDATION = gql`
  query getSLIValidation(
    $imei: String!
    $deviceDefinitionID: ID!
    $organizationID: ID!
    $employeeID: ID!
  ) {
    validateStockListItem(
      imei: $imei
      deviceDefinitionID: $deviceDefinitionID
      organizationID: $organizationID
      employeeID: $employeeID
    ) {
      success
      error {
        code
        message
        details
        __typename
      }
    }
  }
`
